import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api';
import { AffiliateDashboardPromotionInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-promotion-interface';
import { useEffect, useState } from 'react';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export const useAffiliateDashboardPromotion = opened => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    user
  } = useUser();
  const [shouldFetch, setShouldFetch] = useState(false);
  let t1;
  let t2;
  if ($[1] !== opened) {
    t1 = () => {
      if (opened) {
        setShouldFetch(true);
      }
    };
    t2 = [opened];
    $[1] = opened;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== shouldFetch || $[5] !== user) {
    t3 = () => {
      if (!user || !shouldFetch) {
        return;
      }
      return `${AFFILIATE_DASHBOARD_API}/promotion-stats`;
    };
    $[4] = shouldFetch;
    $[5] = user;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useSWR(t3, fetcher);
};